import { useHttpClient } from "../http-client";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import React from "react";

export const useUnlockOrganizationApi = () => {
  const httpClient = useHttpClient();
  const queryClient = useQueryClient();

  const unlock = React.useCallback(
    async (params: {
      organizationId: number;
      isSupervisorMode: boolean;
    }): Promise<void> => {
      await httpClient.post(
        `/classifier/organizations/${params.organizationId}/unlock`,
        {
          id: params.organizationId,
          supervisor: params.isSupervisorMode,
        }
      );
    },
    [httpClient]
  );

  return useMutation({
    mutationFn: unlock,
    onSuccess: () => {
      // Invalidate the dashboard statistics query to refresh the data
      queryClient.invalidateQueries({ queryKey: ["dashboard"] });
    },
  });
};
